import React from "react";
import Culture from "../components/career/Culture";
import Hero from "../components/career/Hero";
import PreFooter from "../components/career/PreFooter";


function Career() {
  return (
    <>
      <Hero />
      <Culture />
      <PreFooter />
    </>
  );
}

export default Career;
